import React from 'react'
import { Controller, useFormContext, type Control, type FieldValues } from 'react-hook-form'
import { Switch, FormControlLabel, FormControl, Box, Typography, type SxProps, type Theme } from '@mui/material'

interface FormSwitchProps {
  name: string
  control?: Control<FieldValues>
  label?: string
  defaultValue?: boolean
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  required?: boolean
  sx?: SxProps<Theme>
  labelStyle?: React.CSSProperties
}

const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  control,
  label,
  defaultValue = false,
  checked,
  defaultChecked,
  disabled = false,
  required = false,
  sx,
  labelStyle
}) => {
  const { control: contextControl } = useFormContext()

  return (
    <FormControl sx={sx} required={required}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Controller
          name={name}
          control={control ?? contextControl}
          defaultValue={defaultValue}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  checked={checked}
                  disabled={disabled}
                  defaultChecked={defaultChecked}
                  inputProps={{ 'aria-label': label }}
                />
              }
              label={<Typography sx={{ fontWeight: 600, ...labelStyle }}>{label}</Typography>}
              style={{
                margin: 0,
                paddingRight: 2
              }}
            />
          )}
        />
      </Box>
    </FormControl>
  )
}

export default FormSwitch
